import React, {Component, Fragment} from 'react';
import ReactTable from 'react-table';
import {tableStyles} from '../shared/styles-table';
import FuseTheme from '../global/theme';

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontSize: '1.015em',
        fontWeight: '400',
        margin: 0,
        padding: '0.15em 0.5em'
    },
    wrapText: {wordWrap: 'break-word'},
    row: {
        display: 'flex',
        width: '100%',
        borderBottom: '1px solid rgb(117, 117, 117)',
    },
    rowTitle: {
        flex: 1,
        fontSize: '0.975em',
        fontWeight: 600,
        padding: '0.5em 1em',
        borderRight: '1px solid rgb(117, 117, 117)'
    },
    rowValue: {
        fontSize: '0.975em',
        flex: 2,
        padding: '0.5em 1em'
    }
};

class DialogInventoryOrderProductDetail extends Component {
    render() {
        const {
            data
        } = this.props;

        const dataArray = [data];

        const warehouseColumns = [
            {
                Header: () => (<span>Available</span>),
                accessor: 'x3_available',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>In Transit</span>),
                accessor: 'x3_in_transit',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Reserved</span>),
                accessor: 'reserved',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
        ];

        const casesColumns = [
            {
                Header: () => (<span>Forecasted Case Qty</span>),
                accessor: 'forecastedCaseQtyTotal',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Requested Case Qty</span>),
                accessor: 'requestedCaseQty',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Overridden Case Qty</span>),
                accessor: 'override_case_qty',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
        ];

        const piecesColumns = [
            {
                Header: () => (<span>Forecasted<br/>Pieces</span>),
                accessor: 'forecastedPiecesTotal',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Pieces<br/>On Hand</span>),
                accessor: 'piecesOnHandTotal',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Requested<br/>Piece Qty</span>),
                accessor: 'requestedPieceQtyTotal',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Pieces<br/>Per Case</span>),
                accessor: 'caseQtyTotal',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Price<br/>Each</span>),
                accessor: 'price_each',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            }
        ];

        const valuesColumns = [
            {
                Header: () => (<span>Forecasted Value</span>),
                accessor: 'forecastedValue',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>On Hand Value</span>),
                accessor: 'onHandValue',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            },
            {
                Header: () => (<span>Requested Value</span>),
                accessor: 'requestedValue',
                sortable: false,
                filterable: false,
                style: {...tableStyles.right, ...tableStyles.noWrapText}
            }
        ];

        return (
            <div className="reports-custom-table-container">
                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Inventory Order - Product Detail</span>
                    </h3>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Product Id</div>
                    <div style={styles.rowValue}>{data.cs_product_id}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Product Name</div>
                    <div style={styles.rowValue}>{data.product_name}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Category</div>
                    <div style={styles.rowValue}>{data.product_category}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Request Type</div>
                    <div style={styles.rowValue}>{data.request_type}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Origin</div>
                    <div style={styles.rowValue}>{data.origin}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Forecast Reorder Multiplier</div>
                    <div style={styles.rowValue}>
                        {(data.origin === 'forecast') ? data.forecast_reorder_multiplier : 'N/A'}
                    </div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Years Sold</div>
                    <div style={styles.rowValue}>
                        {(data.origin === 'forecast') ? data.years_sold : 'N/A'}
                    </div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Last Year Returned Value</div>
                    <div style={styles.rowValue}>
                        {(data.origin === 'forecast') ? data.lastYearReturnedValue : 'N/A'}
                    </div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Case Qty Overridden</div>
                    <div style={styles.rowValue}>
                        {data.override_on_str &&
                            <Fragment>
                                {data.override_on_str}
                                {data.override_by &&
                                    <span> by {data.override_by}</span>
                                }
                            </Fragment>
                        }
                        {!data.override_on_str &&
                            <Fragment>
                                N/A
                            </Fragment>
                        }
                    </div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Location</div>
                    <div style={styles.rowValue}>{data.cs_location} / {data.x3_location} - {data.x3_location_name}</div>
                </div>
                <div style={styles.row}>
                    <div style={styles.rowTitle}>Warehouse</div>
                    <div style={styles.rowValue}>{data.x3_warehouse}</div>
                </div>
                <br/>

                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Availability</span>
                    </h3>
                </div>
                <ReactTable
                    key="table-inventory-order-product-warehouse"
                    data={dataArray}
                    columns={warehouseColumns}
                    defaultPageSize={10}
                    showPagination={false}
                    resizable={false}
                    minRows={1}
                    className="-striped overflow small"
                />

                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Cases</span>
                    </h3>
                </div>
                <ReactTable
                    key="table-inventory-order-product-cases"
                    data={dataArray}
                    columns={casesColumns}
                    defaultPageSize={10}
                    showPagination={false}
                    resizable={false}
                    minRows={1}
                    className="-striped overflow small"
                />

                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Pieces</span>
                    </h3>
                </div>
                <ReactTable
                    key="table-inventory-order-product-pieces"
                    data={dataArray}
                    columns={piecesColumns}
                    defaultPageSize={10}
                    showPagination={false}
                    resizable={false}
                    minRows={1}
                    className="-striped overflow small"
                />

                <div className="reports-table-title small" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Values</span>
                    </h3>
                </div>
                <ReactTable
                    key="table-inventory-order-product-values"
                    data={dataArray}
                    columns={valuesColumns}
                    defaultPageSize={10}
                    showPagination={false}
                    resizable={false}
                    minRows={1}
                    className="-striped overflow"
                />

            </div>
        );
    }
}

export default DialogInventoryOrderProductDetail;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogInventoryOrderProductDetail.js